import React from "react";
import moment from "moment";
import Swal from "sweetalert2";
// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  InputGroup,
  Navbar,
  Nav,
  TabContent,
  TabPane,
  Container,
  Collapse,
  Row,
  Col,
  Tab,
  OverlayTrigger,
  Tooltip,
  Modal,
} from "react-bootstrap";
import { number } from "prop-types";
import DetailPengajuan from "../TabPengajuan/indexSteps";
import PengajuanLama from "../TabPengajuan/pengajuanLama";
import { useDispatch, useSelector } from "react-redux";
import { getAllPengajuan } from "stores/Pengajuan/function";
import { cekStatusPengajuan } from "stores/Pengajuan/function";
import { getPengajuanByIdPengajuan } from "stores/Pengajuan/function";
import { pencairanAll } from "stores/Pengajuan/function";
import CryptoJS from "crypto-js";
import { getScoringByLoan } from "stores/Pengajuan/function";
import PengajuanMonitoring from "./PengajuanMonitoring";

function PengajuanKonsumtif() {
  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 10;
  const modalDetailPengajuan = useSelector((state) => state.pengajuanReducer);

  // console.log(modalDetailPengajuan, "AAAA");
  const auth = useSelector((state) => state.authReducer);
  const pengajuan = useSelector((state) => state.pengajuanReducer);
  const isDetailPengajuanMode = pengajuan.closeTabPengajuan;

  const dispatch = useDispatch();
  const [listPengajuan, setListPengajuan] = React.useState([]);
  const [filterStatus, setFilterStatus] = React.useState(null);
  const [listStatus, setListStatus] = React.useState([]);
  const [searchText, setSearchText] = React.useState("");
  const [loading, setLoading] = React.useState(true);
  const [idPengajuan, setIdPengajuan] = React.useState("");
  const [modalCekStatus, setModalCekStatus] = React.useState(false);
  const [hasilCekStatus, setHasiCekStatus] = React.useState(null);
  const [detailPengajuan, setDetaiPengajuan] = React.useState(null);
  const [pending, setPending] = React.useState(true);
  const [loadError, setLoadError] = React.useState("");
  //Testing Pagination
  const [totalPerHalaman, setTotalPerHalaman] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [appliedFilters, setAppliedFilters] = React.useState({ status: "", search: "" });

  const handlePageSizeChange = (selectedOption) => {
    setTotalPerHalaman(selectedOption.value);
    setPage(0);
  };
  // console.log(handlePageSizeChange, "KKK");
  const handleFilterChange = () => {
    setPage(0);
    setAppliedFilters({ status: filterStatus?.value || "", search: searchText.trim() });
  };

  const handleResetFilters = () => {
    setSearchText("");
    setFilterStatus(null);
    setPage(0);
    setAppliedFilters({ status: "", search: "" });
  };

  const saveToLocalStorage = (data) => {
    // console.log(data, "JJJJ");
    const encryptedData = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      "your-secret-key",
    ).toString();
    localStorage.setItem("detailPengajuan", encryptedData);
  };

  const handleDetailsClick = (val) => {
    // console.log(val, "YYYY");
    dispatch({ type: "SET_DETAIL_PENGAJUAN", data: val });
    dispatch({ type: "SET_CLOSE_TAB", data: true });
    dispatch({ type: "SET_LOADING_DETAIL_PENGAJUAN", data: true });
    // saveToLocalStorage(val);
    getPengajuanByIdPengajuan(dispatch, {
      idPengajuan: val.id_pinjaman,
    }).then((response) => {
      if (response.status === 200) {
        dispatch({ type: "SET_STEP_PENGAJUAN", data: false });
        dispatch({ type: "SET_LOADING_DETAIL_PENGAJUAN", data: false });

        dispatch({ type: "SET_DETAIL_PENGAJUAN", data: response.data.data[0] });
      }
    });
  };

  const hidePengajuanLama = () => {
    dispatch({ type: "SET_PENGAJUAN_LAMA", data: false });
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleClearSearch = () => {
    setSearchText("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleFilterChange();
    }
  };

  React.useEffect(() => {
    if (pengajuan.listPengajuan.data) {
      let tmp = pengajuan.listPengajuan.data.map((val) => {
        let tmpTanggalPengajuanBpd = "";
        let updateBy = "";
        for (var i = 0; i < (val.history || []).length; i++) {
          if (val.history[i].status === "Diproses") {
            tmpTanggalPengajuanBpd = val.history[i].date;
            break;
          }
        }
        for (var i = 0; i < (val.history || []).length; i++) {
          if (val.history[i].status === "Disetujui") {
            updateBy = val.history[i].keterangan;
            break;
          }
        }

        return {
          ...val,
          namaCabangPencairan: !val.lokasiPencairan
            ? "-"
            : val.lokasiPencairan.namaCabang,
          tanggalPengajuanBpd:
            tmpTanggalPengajuanBpd === ""
              ? "-"
              : moment(new Date(tmpTanggalPengajuanBpd)).format("DD MMMM YYYY"),
          tanggalPencairan:
            val.statusPengajuan === "Disetujui" && val.tglAkad && moment(val.tglAkad).isValid()
              ? moment(new Date(val.tglAkad)).format("DD MMMM YYYY")
              : "-",
          diupdateOleh: updateBy === "" ? "-" : updateBy,
          action: (
            <div
              className="d-flex align-items-center justify-content-center"
              style={{ gap: "8px" }}
            >
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Details Pengajuan</Tooltip>}
              >
                <Button
                  className="btn-icon btn-round hover-zoom m-0"
                  aria-label={`Detail pengajuan ${val.namaLengkap || val.id_pinjaman}`}
                  style={{
                    backgroundColor: "#e0f2fe",
                    color: "#0284c7",
                    border: 0,
                    width: "36px",
                    height: "36px",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0 2px 4px rgba(2, 132, 199, 0.15)",
                    padding: 0,
                  }}
                  onClick={() => {
                    handleDetailsClick(val);
                    console.log(val, "LLLL");
                  }}
                >
                  <i className="fas fa-info" style={{ fontSize: "14px" }}></i>
                </Button>
              </OverlayTrigger>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Cek Status Pengajuan</Tooltip>}
              >
                <Button
                  disabled={val.statusPengajuan !== "Diproses"}
                  className="hover-zoom m-0"
                  style={{
                    cursor:
                      val.statusPengajuan !== "Diproses"
                        ? "not-allowed"
                        : "pointer",
                    backgroundColor:
                      val.statusPengajuan !== "Diproses"
                        ? "#f1f5f9"
                        : "#fff7ed",
                    color:
                      val.statusPengajuan !== "Diproses"
                        ? "#94a3b8"
                        : "#ea580c",
                    border:
                      val.statusPengajuan !== "Diproses"
                        ? "1px solid #e2e8f0"
                        : "1px solid #fed7aa",
                    borderRadius: "12px",
                    padding: "6px 16px",
                    fontSize: "12px",
                    fontWeight: "700",
                    boxShadow:
                      val.statusPengajuan !== "Diproses"
                        ? "none"
                        : "0 4px 6px rgba(234, 88, 12, 0.1)",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                  onClick={() => {
                    let siapCek = {
                      idPinjaman: val.id_pinjaman,
                      nik: val.nomorIdentitas,
                    };
                    Swal.fire({
                      title: "Loading ...",
                      allowOutsideClick: false,
                      showConfirmButton: false,
                      onBeforeOpen: () => {
                        Swal.showLoading();
                      },
                    });

                    cekStatusPengajuan(siapCek)
                      .then((response) => {
                        Swal.close();

                        // console.log(response, "OOO");
                        if (response.status === 200) {
                          Swal.fire({
                            title: "Berhasil",
                            text: response.data.message,
                            icon: "success",
                          });
                          getAllPengajuan(dispatch, {
                            status: appliedFilters.status,
                            cari: appliedFilters.search,
                            page: page + 1,
                            limit: totalPerHalaman,
                          });
                          setModalCekStatus(!modalCekStatus);
                          setDetaiPengajuan(val);
                          setHasiCekStatus(response.data);
                        } else {
                          Swal.fire({
                            title: "Gagal",
                            text: "Gagal melakukan cek status",
                            icon: "error",
                          });
                        }
                      })
                      .catch((error) => {
                        // Menutup loading Swal jika terjadi kesalahan
                        Swal.close();
                        console.error("Error:", error);
                      });
                  }}
                >
                  Cek Status
                </Button>
              </OverlayTrigger>
            </div>
          ),
        };
      });
      // console.log(tmp, "KKK");
      setListPengajuan(tmp);
    }
  }, [pengajuan.listPengajuan.data, appliedFilters, page, totalPerHalaman]);

  const options = [
    { value: 10, label: "10" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  React.useEffect(() => {
    let tmp = [
      { value: "", label: "Semua status" },
      {
        value: "Menunggu Konfirmasi",
        label: "Menunggu Konfirmasi",
      },
      {
        value: "Diajukan",
        label: "Diajukan",
      },
      {
        value: "Diajukan (File Gagal Terkirim)",
        label: "Diajukan (File Gagal Terkirim)",
      },
      {
        value: "Diproses (File Gagal Terkirim)",
        label: "Diproses (File Gagal Terkirim)",
      },
      {
        value: "Diproses",
        label: "Diproses",
      },
      {
        value: "Disetujui",
        label: "Disetujui",
      },
      {
        value: "Revisi",
        label: "Revisi",
      },
      {
        value: "Ditolak",
        label: "Ditolak",
      },
    ];
    setListStatus(tmp);
  }, [pengajuan.listPengajuan.data]);

  const getStatusStyle = (status) => {
    switch (status) {
      case "Menunggu Konfirmasi":
        return {
          fontWeight: "700",
          backgroundColor: "#fef3c7",
          textColor: "#d97706",
          border: "1px solid #fde68a",
        };
      case "Diajukan":
        return {
          fontWeight: "700",
          backgroundColor: "#dbeafe",
          textColor: "#2563eb",
          border: "1px solid #bfdbfe",
        };
      case "Diajukan (File Gagal Terkirim)":
        return {
          fontWeight: "700",
          backgroundColor: "#ede9fe",
          textColor: "#7c3aed",
          border: "1px solid #ddd6fe",
        };
      case "Diproses":
        return {
          fontWeight: "700",
          backgroundColor: "#ffedd5",
          textColor: "#ea580c",
          border: "1px solid #fed7aa",
        };
      case "Diproses (File Gagal Terkirim)":
        return {
          fontWeight: "700",
          backgroundColor: "#fee2e2",
          textColor: "#dc2626",
          border: "1px solid #fecaca",
        };
      case "Disetujui":
        return {
          fontWeight: "700",
          backgroundColor: "#dcfce7",
          textColor: "#16a34a",
          border: "1px solid #bbf7d0",
        };
      case "Revisi":
        return {
          fontWeight: "700",
          backgroundColor: "#fee2e2",
          textColor: "#e11d48",
          border: "1px solid #fecaca",
        };
      case "Ditolak":
        return {
          fontWeight: "700",
          backgroundColor: "#ef4444",
          textColor: "#ffffff",
          border: "1px solid #dc2626",
        };
      default:
        return {};
    }
  };

  // const getStatusStyleSelect = (status) => {
  //   switch (status) {
  //     case "Menunggu Konfirmasi":
  //       return { textColor: "#FFAF05" };
  //     case "Diajukan":
  //       return { textColor: "#1776F1" };
  //     case "Diproses":
  //       return { textColor: "#fa5d02" };
  //     case "Disetujui":
  //       return { textColor: "#5AC967" };
  //     case "Revisi":
  //       return { textColor: "#FF2B4B" };
  //     case "Ditolak":
  //       return { textColor: "#E10F00" };
  //     default:
  //       return {};
  //   }
  // };

  // const customStylesSelect = {
  //   option: (provided, state) => ({
  //     ...provided,
  //     backgroundColor: getStatusStyleSelect(state.label).backgroundColor,
  //     color: getStatusStyleSelect(state.data.label).textColor,
  //     padding: "8px",
  //     borderRadius: "4px",
  //   }),
  // };

  const renderStatus = (row) => {
    const statusStyle = getStatusStyle(row.statusPengajuan);
    return (
      <span className="pengajuan-status-badge" style={{
        backgroundColor: statusStyle.backgroundColor || "#f1f5f9",
        color: statusStyle.textColor || "#475569",
        border: statusStyle.border || "1px solid #cbd5e1",
      }}>
        {row.statusPengajuan || "Belum tersedia"}
      </span>
    );
  };

  const colPengajuan = [
    {
      id: "no", name: "No", width: "64px", center: true,
      selector: (row, index) => index + (pengajuan.listPengajuan.pagingCounter || page * totalPerHalaman + 1),
    },
    {
      id: "referensi", name: "Referensi ID", width: "260px",
      selector: (row) => row.id_pinjaman || "-",
      cell: (row) => (
        <div className="pengajuan-reference">
          <span>{row.id_pinjaman || "-"}</span>
          {row.id_pinjaman && (
            <button type="button" className="pengajuan-copy" aria-label={`Salin referensi ${row.id_pinjaman}`} title="Salin referensi"
              onClick={async () => {
                try {
                  await navigator.clipboard.writeText(row.id_pinjaman);
                  Swal.fire({ icon: "success", title: "Referensi disalin", timer: 1500, showConfirmButton: false });
                } catch {
                  Swal.fire({ icon: "error", title: "Tidak dapat menyalin", text: "Silakan pilih dan salin referensi secara manual." });
                }
              }}>
              <i className="far fa-copy" aria-hidden="true" />
            </button>
          )}
        </div>
      ),
    },
    {
      id: "nasabah", name: "Calon Nasabah", width: "240px", wrap: true,
      style: { fontWeight: 600, color: "#0f172a" },
      selector: (row) => row.namaLengkap || "-",
    },
    {
      id: "status", name: "Status", minWidth: "260px", center: true,
      selector: (row) => row.statusPengajuan, cell: renderStatus,
    },
    {
      name: "Cabang Pencairan", minWidth: "240px", wrap: true,
      selector: (row) => row.namaCabangPencairan || "-",
    },
    {
      name: "Marketing", minWidth: "220px", wrap: true,
      selector: (row) => row.marketing?.nama || "-",
    },
    {
      name: "Supervisor", minWidth: "220px", wrap: true,
      selector: (row) => row.supervisor?.nama || "-",
    },
    {
      name: "Diajukan ke Supervisor", minWidth: "240px", center: true,
      selector: (row) => row.createdAt && moment(row.createdAt).isValid() ? moment(row.createdAt).format("DD MMMM YYYY") : "-",
    },
    {
      name: "Tanggal Pencairan", minWidth: "200px", center: true,
      selector: (row) => row.tanggalPencairan || "-",
    },
    {
      name: "Tujuan Penggunaan", minWidth: "200px", center: true,
      selector: (row) => !row.stepEmpat?.tujuanPenggunaan ? "-" : row.stepEmpat.tujuanPenggunaan === "3" ? "Konsumtif" : "Produktif",
    },
    {
      id: "aksi", name: "Aksi", width: "196px", center: true,
      cell: (row) => row.action,
    },
  ];

  React.useEffect(() => {
    let active = true;
    setPending(true);
    setLoadError("");
    getAllPengajuan(dispatch, {
      status: appliedFilters.status,
      cari: appliedFilters.search,
      page: page + 1,
      limit: totalPerHalaman,
    })
      .then((result) => {
        if (result !== 200) throw new Error("Gagal memuat pengajuan");
      })
      .catch(() => {
        if (active) setLoadError("Data pengajuan belum dapat dimuat. Silakan coba lagi.");
      })
      .finally(() => {
        if (active) setPending(false);
      });
    return () => { active = false; };
  }, [dispatch, modalDetailPengajuan.modalDetailPengajuan, page, totalPerHalaman, appliedFilters]);

  React.useEffect(() => {
    if (pending || loadError) return;
    const totalPages = Number(pengajuan.listPengajuan.totalPages);
    if (Number.isFinite(totalPages) && page > Math.max(0, totalPages - 1)) {
      setPage(Math.max(0, totalPages - 1));
    }
  }, [pending, loadError, page, pengajuan.listPengajuan.totalPages]);

  return (
    <>
      <Modal
        size="lg"
        show={modalCekStatus}
        onHide={() => setModalCekStatus(!modalCekStatus)}
        className="pengajuan-status-modal"
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton></Modal.Header>
        <Col md="12" style={{ marginTop: 20 }}>
          <Card className="stacked-form">
            <Card.Header>
              <Card.Title
                as="h4"
                style={{ color: "black", fontWeight: "bold" }}
              >
                Cek Status Pengajuan
                <hr></hr>
              </Card.Title>
            </Card.Header>
            <Card.Body>
              {hasilCekStatus &&
              (hasilCekStatus.status === "101" ||
                hasilCekStatus.status === "200") ? (
                <>
                  <Row>
                    <Col sm="3">
                      <label
                        style={{
                          textTransform: "none",
                          fontSize: 14,
                          color: "black",
                        }}
                      >
                        Refference ID
                      </label>
                    </Col>
                    <Col sm="o">
                      <label
                        style={{
                          textTransform: "none",
                          fontSize: 14,
                          color: "black",
                        }}
                      >
                        :
                      </label>
                    </Col>
                    <Col sm="6">
                      <label
                        style={{
                          textTransform: "none",
                          fontSize: 14,
                          color: "black",
                        }}
                      >
                        {detailPengajuan && detailPengajuan.id_pinjaman}
                      </label>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="3">
                      <label
                        style={{
                          textTransform: "none",
                          fontSize: 14,
                          color: "black",
                        }}
                      >
                        Nama Nasabah
                      </label>
                    </Col>
                    <Col sm="o">
                      <label
                        style={{
                          textTransform: "none",
                          fontSize: 14,
                          color: "black",
                        }}
                      >
                        :
                      </label>
                    </Col>
                    <Col sm="6">
                      <label
                        style={{
                          textTransform: "none",
                          fontSize: 14,
                          color: "black",
                        }}
                      >
                        {detailPengajuan && detailPengajuan.namaLengkap}
                      </label>
                    </Col>
                  </Row>
                  {/* <Row>
                    <Col sm="3">
                      <label
                        style={{
                          textTransform: "none",
                          fontSize: 14,
                          color: "black",
                        }}
                      >
                        Status Pengajuan
                      </label>
                    </Col>
                    <Col sm="o">
                      <label
                        style={{
                          textTransform: "none",
                          fontSize: 14,
                          color: "black",
                        }}
                      >
                        :
                      </label>
                    </Col>
                    <Col sm="6">
                      <label
                        style={{
                          textTransform: "none",
                          fontSize: 14,
                          color: "black",
                        }}
                      >
                        {hasilCekStatus && hasilCekStatus.keterangan}
                      </label>
                    </Col>
                  </Row> */}
                </>
              ) : (
                <>
                  <Row>
                    <Col sm="3">
                      <li>
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          Refference ID
                        </label>
                      </li>
                    </Col>
                    <Col sm="o">
                      <label
                        style={{
                          textTransform: "none",
                          fontSize: 14,
                          color: "black",
                        }}
                      >
                        :
                      </label>
                    </Col>
                    <Col sm="6">
                      <label
                        style={{
                          textTransform: "none",
                          fontSize: 14,
                          color: "black",
                        }}
                      >
                        {detailPengajuan && detailPengajuan.id_pinjaman}
                      </label>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="3">
                      <li>
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          Nama Nasabah
                        </label>
                      </li>
                    </Col>
                    <Col sm="o">
                      <label
                        style={{
                          textTransform: "none",
                          fontSize: 14,
                          color: "black",
                        }}
                      >
                        :
                      </label>
                    </Col>
                    <Col sm="6">
                      <label
                        style={{
                          textTransform: "none",
                          fontSize: 14,
                          color: "black",
                        }}
                      >
                        {detailPengajuan && detailPengajuan.namaLengkap}
                      </label>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="3">
                      <li>
                        <label
                          style={{
                            textTransform: "none",
                            fontSize: 14,
                            color: "black",
                          }}
                        >
                          Pesan
                        </label>
                      </li>
                    </Col>
                    <Col sm="o">
                      <label
                        style={{
                          textTransform: "none",
                          fontSize: 14,
                          color: "black",
                        }}
                      >
                        :
                      </label>
                    </Col>
                    <Col sm="6">
                      <label
                        style={{
                          textTransform: "none",
                          fontSize: 14,
                          color: "black",
                        }}
                      >
                        {hasilCekStatus && hasilCekStatus.message}
                      </label>
                    </Col>
                  </Row>
                </>
              )}
            </Card.Body>

            <Card.Footer></Card.Footer>
          </Card>
        </Col>
      </Modal>

      {modalDetailPengajuan.pengajuanLama ? (
        <>
          {modalDetailPengajuan.modalDetailPengajuan ? (
            <>
              {!isDetailPengajuanMode && (
                <PengajuanMonitoring
                  rows={listPengajuan}
                  columns={colPengajuan}
                  pending={pending}
                  error={loadError}
                  page={page}
                  pageCount={Number(pengajuan.listPengajuan.totalPages) || 0}
                  pageSize={totalPerHalaman}
                  pageSizeOptions={options}
                  search={searchText}
                  onSearch={handleSearch}
                  status={filterStatus}
                  statusOptions={listStatus}
                  onStatus={setFilterStatus}
                  appliedFilters={appliedFilters}
                  onApply={handleFilterChange}
                  onReset={handleResetFilters}
                  onRefresh={() => setAppliedFilters({ ...appliedFilters })}
                  onPageChange={setPage}
                  onPageSizeChange={handlePageSizeChange}
                />
              )}
            </>
          ) : (
            <>
              <DetailPengajuan />
            </>
          )}
        </>
      ) : (
        <PengajuanLama />
      )}
    </>
  );
}

export default PengajuanKonsumtif;
